import Stack from "@mui/material/Stack"
import CircularProgress from "@mui/material/CircularProgress"
import Typography from "@mui/material/Typography"
import React from "react"

const ProcessingDataInfo:React.FC<{customLabel?: string}> = ({ customLabel }) => {
  return <Stack direction="row" alignItems="center" my={1}><CircularProgress /><Typography fontSize={18} ml={1}>{customLabel || 'Processing data...'}</Typography></Stack>
}

export default ProcessingDataInfo